import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { CalendarLayout } from '../../components/v0/CalendarLayout';
import { Calendar } from './Calendar';
import { ViewToggleButtons } from '../../components/v0/calendar/ViewToggleButtons';
import FullCalendar from '@fullcalendar/react'; // Needed for Ref type

// Define CalendarView type (can be moved to a shared types file later)
type CalendarView = 'dayGridMonth' | 'timeGridWeek' | 'timeGridDay' | 'listWeek';

export const CalendarPageWrapper = () => {
  const { t } = useTranslation(['v0/calendar']);
  const [calendarView, setCalendarView] = useState<CalendarView>('dayGridMonth');
  const calendarRef = useRef<FullCalendar | null>(null);

  // Define the custom action using the state and ref managed here
  const calendarCustomAction = (
    <ViewToggleButtons 
      calendarView={calendarView} 
      setCalendarView={setCalendarView} 
      calendarRef={calendarRef} 
    />
  );

  return (
    <CalendarLayout
      title={t('v0/calendar:title')}
      customAction={calendarCustomAction}
      // Add onRefresh if needed, potentially triggering project/task fetches
      // showRefreshButton={true} 
      // onRefresh={() => { /* logic to refetch data */ }}
    >
      {/* Pass the state and ref down to the Calendar component */}
      <Calendar 
         calendarView={calendarView} 
         setCalendarView={setCalendarView} 
         calendarRef={calendarRef} 
      />
    </CalendarLayout>
  );
}; 